import Query from '../../../components/Report';

export const queryold = new Query('search-algo-comparison');

export const query = new Query('search-summary-min-max-date');
